import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-col-carousel',
  templateUrl: './one-col-carousel.component.html',
  styleUrls: ['./one-col-carousel.component.css']
})
export class OneColCarouselComponent implements OnInit {

  @Input() oneColCarousel_items: any[] = []

  constructor() { }

  ngOnInit(): void {


  }

}
